import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

const FtpsEditDialog = ({ open, formValues, setFormValues, onClose, onSave, originalValues }: any) => {
  const isDirty = JSON.stringify(formValues) !== JSON.stringify(originalValues);
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit FTP Configuration</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} sx={{ mt: 1 }}>
          <TextField label="Billing Client Name" value={formValues.billing_client_name || ''} fullWidth disabled />
          <TextField
            label="Partial Client Name"
            value={formValues.partial_client_name || ''}
            onChange={(e) => setFormValues({ ...formValues, partial_client_name: e.target.value })}
            fullWidth
          />
          <TextField
            label="FTP Folder"
            value={formValues.ftp_folder_name || ''}
            onChange={(e) => setFormValues({ ...formValues, ftp_folder_name: e.target.value })}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="primary" variant="contained" onClick={onSave} disabled={!isDirty}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FtpsEditDialog;
